import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import DashboardContainer from 'containers/DashboardContainer'
import Panel from '../components/Panel'
import LoginPoll from '../components/LoginPoll'

import { DESTINATION_TYPES_CONSTANTS } from 'src/constants'
import {
  showEmailFieldSelector,
  showPhoneFieldSelector,
  showPhoneCodeFieldSelector,
  loginFormSelector,
  signUpDetailSelector
} from 'src/selectors'
import { parseEventUrl } from 'services/url_helpers'

export class SubscribePanel extends React.Component {
  getPollDetail = () => {
    const { signUpDetail, poll } = this.props
    const { destinationType } = parseEventUrl(window.location.pathname)
    switch (destinationType) {
      case DESTINATION_TYPES_CONSTANTS.signUp:
        return signUpDetail || {}
      case DESTINATION_TYPES_CONSTANTS.timepoll:
        return poll || {}
      default:
        return {}
    }
  }

  _formatPhoneNumber(phoneNumber) {
    const areaCode = phoneNumber.substr(1, 3)
    const prefix = phoneNumber.substr(4, 3)
    const suffix = phoneNumber.substr(7, 4)

    return `(${areaCode}) ${prefix}-${suffix}`
  }
  _getTitle = ({ showPhoneField, showEmailField, showPhoneCodeField, data = {} }) => {
    const { loginForm } = this.props
    const { destinationType } = parseEventUrl(window.location.pathname)
    const titleOption = {
      pollLogin: {
        title: 'Thank you for participating!',
        subtitle:
          'Create an account to get updates on ' +
          data?.name +
          ' and to create your own polls for free'
      },
      confirmNumber: {
        title: 'Confirm Number',
        subtitle:
          'A code was sent to ' +
          this._formatPhoneNumber(loginForm.phoneNumber) +
          '.' +
          ' Enter it here to verify your number'
      },
      enterEmail: {
        title: 'Enter an Email',
        subtitle: 'Enter the email where you want to receive updates about this poll'
      },
      signUpLogin: {
        title: 'Thank you for participating!',
        subtitle: 'Sign up for updates about "' + data.name + '".'
      }
    }

    if (showPhoneField) {
      if (destinationType === DESTINATION_TYPES_CONSTANTS.signUp) {
        return titleOption.signUpLogin
      }
      return titleOption.pollLogin
    }
    if (showPhoneCodeField) {
      return titleOption.confirmNumber
    }
    if (showEmailField) {
      return titleOption.enterEmail
    }
  }
  render() {
    const { showPhoneField, showEmailField, showPhoneCodeField, onNextStep, handleBackClick } =
      this.props
    const isSecondButton = true
    const data = this.getPollDetail()
    return (
      <DashboardContainer>
        <Panel
          isSecondButton={isSecondButton}
          notification={this._getTitle({
            showPhoneField,
            showEmailField,
            showPhoneCodeField,
            data
          })}
          handleBackClick={handleBackClick}
          showCreateButton
        >
          <LoginPoll onNextStep={onNextStep} isSubscribePoll />
        </Panel>
      </DashboardContainer>
    )
  }
}

SubscribePanel.propTypes = {
  poll: PropTypes.object,
  loginForm: PropTypes.object,
  showEmailField: PropTypes.bool,
  showPhoneCodeField: PropTypes.bool,
  showPhoneField: PropTypes.bool,
  onNextStep: PropTypes.func,
  handleBackClick: PropTypes.func,
  signUpDetail: PropTypes.object
}

function mapStateToProps(state) {
  const showPhoneCodeField = showPhoneCodeFieldSelector(state)
  const showEmailField = showEmailFieldSelector(state)
  const showPhoneField = showPhoneFieldSelector(state)
  const loginForm = loginFormSelector(state)
  return {
    poll: state.frontend.timePoll,
    loginForm,
    customUser: state.frontend.customUser,
    showPhoneCodeField,
    showEmailField,
    showPhoneField,
    route: state.routing.locationBeforeTransitions,
    signUpDetail: signUpDetailSelector(state)
  }
}

export default connect(mapStateToProps)(SubscribePanel)



// WEBPACK FOOTER //
// ./src/containers/time-poll/panels/SubscribeContainer.jsx